import React from 'react';
import { SvgIcon } from '../../components/svgIcon';
import { SvgIconProps } from '../../components/svgIcon/model';

export const ChatHatchedIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon
      // cacheName="hatched/chat"
      ref={ref as any}
      {...props}
    >
      <g clipPath="url(#clip0_315_176)">
        <mask height="22" id="mask0_315_176" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }} width="22" x="3" y="3">
          <path
            d="M4 23.5936C5.45881 18.8554 6.88626 16.072 7.9686 14.3675C8.34509 13.789 8.95685 12.8663 9.74116 11.3964C10.7294 9.55125 10.949 8.73809 11.8901 7.018C12.3137 6.23613 12.9254 5.18843 13.7725 4"
            fill="#FFCEC3"
          />
          <path
            d="M4 23.5936C5.45881 18.8554 6.88626 16.072 7.9686 14.3675C8.34509 13.789 8.95685 12.8663 9.74116 11.3964C10.7294 9.55125 10.949 8.73809 11.8901 7.018C12.3137 6.23613 12.9254 5.18843 13.7725 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 19.3245C4.54902 18.3394 4.97254 17.495 5.30195 16.8226C5.59999 16.1971 6.05489 15.2588 6.55685 14.0079C7.05881 12.7569 7.07449 12.5223 7.49802 11.6623C7.95292 10.724 8.04705 10.7866 8.48623 9.89528C9.05095 8.73809 8.90977 8.62864 9.53721 7.28383C10.0392 6.18922 10.5098 5.46991 10.6823 5.20407C11.0117 4.70368 11.3255 4.29711 11.5764 4"
            fill="#FFCEC3"
          />
          <path
            d="M4 19.3245C4.54902 18.3394 4.97254 17.495 5.30195 16.8226C5.59999 16.1971 6.05489 15.2588 6.55685 14.0079C7.05881 12.7569 7.07449 12.5223 7.49802 11.6623C7.95292 10.724 8.04705 10.7866 8.48623 9.89528C9.05095 8.73809 8.90977 8.62864 9.53721 7.28383C10.0392 6.18922 10.5098 5.46991 10.6823 5.20407C11.0117 4.70368 11.3255 4.29711 11.5764 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 16.0407C4.15686 15.556 4.43921 14.7585 4.84705 13.8202C5.27058 12.8664 5.41176 12.6943 6.10195 11.2088C6.58822 10.1611 6.58822 10.0986 7.15292 8.91011C7.63919 7.87804 7.749 7.6904 8.06273 7.03364C8.39214 6.3456 8.84704 5.31354 9.31762 4"
            fill="#FFCEC3"
          />
          <path
            d="M4 16.0407C4.15686 15.556 4.43921 14.7585 4.84705 13.8202C5.27058 12.8664 5.41176 12.6943 6.10195 11.2088C6.58822 10.1611 6.58822 10.0986 7.15292 8.91011C7.63919 7.87804 7.749 7.6904 8.06273 7.03364C8.39214 6.3456 8.84704 5.31354 9.31762 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 11.9435C4.48627 10.7707 4.94117 9.83243 5.27058 9.20697C5.8196 8.12797 6.10195 7.6745 6.63528 6.64243C7.1843 5.53218 7.57645 4.60958 7.82742 4.01537"
            fill="#FFCEC3"
          />
          <path
            d="M4 11.9435C4.48627 10.7707 4.94117 9.83243 5.27058 9.20697C5.8196 8.12797 6.10195 7.6745 6.63528 6.64243C7.1843 5.53218 7.57645 4.60958 7.82742 4.01537"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 8.61272C4.21961 8.15927 4.43921 7.70577 4.64313 7.22101C4.98823 6.43915 5.09803 6.09513 5.41176 5.42272C5.56862 5.06307 5.80391 4.57831 6.10195 4.01537"
            fill="#FFCEC3"
          />
          <path
            d="M4 8.61272C4.21961 8.15927 4.43921 7.70577 4.64313 7.22101C4.98823 6.43915 5.09803 6.09513 5.41176 5.42272C5.56862 5.06307 5.80391 4.57831 6.10195 4.01537"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 5.28199C4.1098 5.14125 4.26667 4.93797 4.39216 4.68777C4.51764 4.42194 4.59608 4.18738 4.64313 4.01537"
            fill="#FFCEC3"
          />
          <path
            d="M4 5.28199C4.1098 5.14125 4.26667 4.93797 4.39216 4.68777C4.51764 4.42194 4.59608 4.18738 4.64313 4.01537"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M5.19214 23.9063C5.41174 23.5466 5.75684 22.9837 6.10194 22.2487C6.72939 20.9352 6.8235 20.2628 7.3882 18.8398C7.89017 17.5732 8.37644 16.6506 8.64312 16.1658C9.49015 14.5864 9.74115 14.5396 10.7294 12.8038C11.498 11.459 11.3411 11.5059 12.2666 9.84835C13.1293 8.2846 13.396 8.0188 13.9764 6.8929C14.5882 5.68883 14.9803 4.64113 15.1999 4"
            fill="#FFCEC3"
          />
          <path
            d="M5.19214 23.9063C5.41174 23.5466 5.75684 22.9837 6.10194 22.2487C6.72939 20.9352 6.8235 20.2628 7.3882 18.8398C7.89017 17.5732 8.37644 16.6506 8.64312 16.1658C9.49015 14.5864 9.74115 14.5396 10.7294 12.8038C11.498 11.459 11.3411 11.5059 12.2666 9.84835C13.1293 8.2846 13.396 8.0188 13.9764 6.8929C14.5882 5.68883 14.9803 4.64113 15.1999 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M6.72949 23.9063C7.09027 23.4684 7.60792 22.796 8.15692 21.9047C9.14517 20.2941 9.25495 19.5122 10.4157 16.8695C11.0902 15.337 11.4824 14.4614 12.1569 13.2885C12.9726 11.8812 13.1922 11.8187 14.353 9.87961C14.9177 8.95704 15.4824 8.00317 16.0941 6.68962C16.5961 5.61064 16.9412 4.68804 17.1765 4"
            fill="#FFCEC3"
          />
          <path
            d="M6.72949 23.9063C7.09027 23.4684 7.60792 22.796 8.15692 21.9047C9.14517 20.2941 9.25495 19.5122 10.4157 16.8695C11.0902 15.337 11.4824 14.4614 12.1569 13.2885C12.9726 11.8812 13.1922 11.8187 14.353 9.87961C14.9177 8.95704 15.4824 8.00317 16.0941 6.68962C16.5961 5.61064 16.9412 4.68804 17.1765 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M9.01965 23.9063C9.28633 23.3277 9.63142 22.5615 10.0706 21.6702C11.0902 19.5122 11.8902 17.9172 12.0942 17.5419C12.5177 16.7131 13.2549 15.2589 14.2118 13.4762C15.2941 11.4746 15.4823 11.24 16.2667 9.69197C16.8314 8.58171 17.302 7.6122 17.6941 6.8147C18.2274 5.70446 18.6823 4.75058 19.0117 4.01562"
            fill="#FFCEC3"
          />
          <path
            d="M9.01965 23.9063C9.28633 23.3277 9.63142 22.5615 10.0706 21.6702C11.0902 19.5122 11.8902 17.9172 12.0942 17.5419C12.5177 16.7131 13.2549 15.2589 14.2118 13.4762C15.2941 11.4746 15.4823 11.24 16.2667 9.69197C16.8314 8.58171 17.302 7.61221 17.6941 6.8147C18.2274 5.70446 18.6823 4.75058 19.0117 4.01562"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9999 4.39096C22.541 9.12905 21.1136 11.9125 20.0313 13.617C19.6548 14.1956 19.043 15.1182 18.2587 16.5881C17.2705 18.4333 17.0509 19.2464 16.1097 20.9665C15.6862 21.7484 15.0744 22.7961 14.2274 23.9845"
            fill="#FFCEC3"
          />
          <path
            d="M23.9999 4.39096C22.541 9.12905 21.1136 11.9125 20.0313 13.617C19.6548 14.1956 19.043 15.1182 18.2587 16.5881C17.2705 18.4333 17.0509 19.2464 16.1097 20.9665C15.6862 21.7484 15.0744 22.7961 14.2274 23.9845"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M24 8.67541C23.451 9.66058 23.0117 10.505 22.698 11.1774C22.4 11.8029 21.9451 12.7411 21.4431 13.9921C20.9411 15.2431 20.9255 15.4776 20.502 16.3377C20.0471 17.2759 19.9529 17.2134 19.5137 18.1047C18.9333 19.2462 19.0745 19.3713 18.4628 20.7005C17.9608 21.7951 17.4902 22.5144 17.3176 22.7803C16.9882 23.2807 16.6745 23.6872 16.4235 23.9843"
            fill="#FFCEC3"
          />
          <path
            d="M24 8.67541C23.451 9.66058 23.0117 10.505 22.698 11.1774C22.4 11.8029 21.9451 12.7411 21.4431 13.9921C20.9411 15.2431 20.9255 15.4776 20.502 16.3377C20.0471 17.2759 19.9529 17.2134 19.5137 18.1047C18.9333 19.2462 19.0745 19.3713 18.4628 20.7005C17.9608 21.7951 17.4902 22.5144 17.3176 22.7803C16.9882 23.2807 16.6745 23.6872 16.4235 23.9843"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M24 11.9593C23.8431 12.444 23.5608 13.2415 23.1529 14.1798C22.7294 15.1336 22.5882 15.3057 21.898 16.7912C21.4118 17.8389 21.4118 17.9015 20.847 19.0899C20.3608 20.1219 20.251 20.3096 19.9372 20.9664C19.6078 21.6544 19.1529 22.6865 18.6823 24"
            fill="#FFCEC3"
          />
          <path
            d="M24 11.9593C23.8431 12.444 23.5608 13.2415 23.1529 14.1798C22.7294 15.1336 22.5882 15.3057 21.898 16.7912C21.4118 17.8389 21.4118 17.9015 20.847 19.0899C20.3608 20.1219 20.251 20.3096 19.9372 20.9664C19.6078 21.6544 19.1529 22.6865 18.6823 24"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9999 16.0563C23.4979 17.2291 23.043 18.1673 22.7293 18.7928C22.1803 19.8718 21.8979 20.3252 21.3646 21.3573C20.8156 22.4676 20.4234 23.3902 20.1724 23.9844"
            fill="#FFCEC3"
          />
          <path
            d="M23.9999 16.0563C23.4979 17.2291 23.043 18.1673 22.7293 18.7928C22.1803 19.8718 21.8979 20.3252 21.3646 21.3573C20.8156 22.4676 20.4234 23.3902 20.1724 23.9844"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9999 19.3872C23.7802 19.8406 23.5606 20.2941 23.3567 20.7789C23.0116 21.5608 22.9018 21.9048 22.5881 22.5772C22.4312 22.9368 22.1959 23.4216 21.8979 23.9845"
            fill="#FFCEC3"
          />
          <path
            d="M23.9999 19.3872C23.7802 19.8406 23.5606 20.2941 23.3567 20.7789C23.0116 21.5608 22.9018 21.9048 22.5881 22.5772C22.4312 22.9368 22.1959 23.4216 21.8979 23.9845"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9998 22.7179C23.8744 22.8587 23.7332 23.0463 23.592 23.3121C23.4665 23.578 23.3881 23.8125 23.341 23.9846"
            fill="#FFCEC3"
          />
          <path
            d="M23.9998 22.7179C23.8744 22.8587 23.7332 23.0463 23.592 23.3121C23.4665 23.578 23.3881 23.8125 23.341 23.9846"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M22.7921 4.07827C22.5725 4.43793 22.2274 5.00087 21.8823 5.72019C21.2548 7.03372 21.1607 7.70612 20.596 9.12914C20.0941 10.3957 19.6078 11.3184 19.3411 11.8031C18.4941 13.3825 18.2431 13.4294 17.2549 15.1651C16.4863 16.5099 16.6431 16.463 15.7176 18.1206C14.8549 19.6843 14.5882 19.9501 14.0078 21.076C13.3961 22.2801 13.0039 23.3278 12.7843 23.9689"
            fill="#FFCEC3"
          />
          <path
            d="M22.7921 4.07827C22.5725 4.43793 22.2274 5.00087 21.8823 5.72019C21.2548 7.03372 21.1607 7.70612 20.596 9.12914C20.0941 10.3957 19.6078 11.3184 19.3411 11.8031C18.4941 13.3825 18.2431 13.4294 17.2549 15.1651C16.4863 16.5099 16.6431 16.463 15.7176 18.1206C14.8549 19.6843 14.5882 19.9501 14.0078 21.076C13.3961 22.2801 13.0039 23.3278 12.7843 23.9689"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M21.2704 4.07827C20.9096 4.51611 20.392 5.18852 19.843 6.07985C18.8547 7.69049 18.7449 8.47237 17.5842 11.1151C16.9096 12.6475 16.5175 13.5232 15.843 14.696C15.0273 16.1033 14.8077 16.1659 13.6469 18.1049C13.0822 19.0275 12.5175 19.9814 11.9057 21.2949C11.4038 22.3739 11.0587 23.2965 10.8234 23.9846"
            fill="#FFCEC3"
          />
          <path
            d="M21.2704 4.07827C20.9096 4.51611 20.392 5.18852 19.843 6.07985C18.8547 7.69049 18.7449 8.47237 17.5842 11.1151C16.9096 12.6475 16.5175 13.5232 15.843 14.696C15.0273 16.1033 14.8077 16.1659 13.6469 18.1049C13.0822 19.0275 12.5175 19.9814 11.9057 21.2949C11.4038 22.3739 11.0587 23.2965 10.8234 23.9846"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
        </mask>
        <g mask="url(#mask0_315_176)">
          <path
            d="M13.9922 24.1095C19.58 24.1095 24.1098 19.5833 24.1098 14C24.1098 8.41669 19.58 3.8905 13.9922 3.8905C8.40437 3.8905 3.87457 8.41669 3.87457 14C3.87457 19.5833 8.40437 24.1095 13.9922 24.1095Z"
            fill="#FFCEC3"
          />
        </g>
        <path
          d="M12.6341 1.78454H1.90097C1.40416 1.78454 1 2.23921 1 2.79809V10.0423C1 10.6011 1.40416 11.0559 1.90097 11.0559H2.59694V13.7527C2.59694 13.9244 2.68888 14.0793 2.82994 14.145C2.87663 14.1668 2.92569 14.1774 2.97432 14.1774C3.07257 14.1774 3.16907 14.1342 3.24129 14.053L5.90538 11.0559H6.43989C6.64836 11.0559 6.81732 10.8658 6.81732 10.6313C6.81732 10.3967 6.64829 10.2066 6.43989 10.2066C6.43989 10.2066 5.73082 10.2072 5.72342 10.208C5.63554 10.2147 5.54929 10.2555 5.4821 10.331L3.35182 12.7276C3.35182 12.7276 3.35116 10.6044 3.34994 10.5934C3.33291 10.3766 3.17129 10.2066 2.97419 10.2066H1.90097C1.82041 10.2066 1.75491 10.1329 1.75491 10.0423V2.79809C1.75491 2.70746 1.82044 2.63377 1.90097 2.63377H12.6341C12.7146 2.63377 12.7801 2.7075 12.7801 2.79809V5.57738C12.7801 5.81191 12.9492 6.002 13.1576 6.002C13.366 6.002 13.535 5.81191 13.535 5.57738V2.79809C13.535 2.23921 13.1309 1.78454 12.6341 1.78454Z"
          fill="#FF7870"
        />
        <path
          d="M16.0991 6.97817H8.58609C8.08931 6.97817 7.68512 7.43285 7.68512 7.99176V12.9337C7.68512 13.4926 8.08928 13.9473 8.58609 13.9473H13.2897L15.1953 16.0911C15.2675 16.1724 15.364 16.2155 15.4623 16.2155C15.5109 16.2155 15.5599 16.2049 15.6066 16.1832C15.7476 16.1174 15.8396 15.9626 15.8396 15.7908V13.9472H16.099C16.5958 13.9472 17 13.4926 17 12.9337V7.99173C17 7.43285 16.5959 6.97817 16.0991 6.97817ZM16.2452 12.9337C16.2452 13.0243 16.1796 13.098 16.0991 13.098H15.4624C15.2637 13.098 15.1013 13.2707 15.0864 13.4899C15.0854 13.4992 15.0848 14.7657 15.0848 14.7657L13.7143 13.2239C13.7129 13.2223 13.7114 13.2208 13.71 13.2192C13.7046 13.2133 13.6995 13.2082 13.6947 13.2035C13.6283 13.138 13.5415 13.098 13.4462 13.098H8.58609C8.50553 13.098 8.44003 13.0243 8.44003 12.9337V7.99173C8.44003 7.9011 8.50556 7.82741 8.58609 7.82741H16.0991C16.1796 7.82741 16.2452 7.90113 16.2452 7.99173V12.9337V12.9337Z"
          fill="#FF7870"
        />
        <path
          d="M12.3426 10.0385C12.1343 10.0385 11.9652 10.2287 11.9652 10.4631C11.9652 10.6975 12.1343 10.8877 12.3426 10.8877C12.551 10.8877 12.7201 10.6975 12.7201 10.4631C12.7201 10.2287 12.551 10.0385 12.3426 10.0385Z"
          fill="#FF7870"
        />
        <path
          d="M10.7023 4.59166H3.83282C3.62438 4.59166 3.45538 4.78175 3.45538 5.01628C3.45538 5.25081 3.62441 5.4409 3.83282 5.4409H10.7023C10.9107 5.4409 11.0797 5.25081 11.0797 5.01628C11.0797 4.78175 10.9107 4.59166 10.7023 4.59166Z"
          fill="#FF7870"
        />
        <path
          d="M6.43986 7.39924H3.83282C3.62438 7.39924 3.45538 7.58933 3.45538 7.82386C3.45538 8.05838 3.62442 8.24847 3.83282 8.24847H6.43986C6.64833 8.24847 6.8173 8.05838 6.8173 7.82386C6.8173 7.58933 6.6483 7.39924 6.43986 7.39924Z"
          fill="#FF7870"
        />
        <path
          d="M10.5887 10.0385C10.3804 10.0385 10.2112 10.2287 10.2112 10.4631C10.2112 10.6975 10.3804 10.8877 10.5887 10.8877C10.7971 10.8877 10.9661 10.6975 10.9661 10.4631C10.9661 10.2287 10.7971 10.0385 10.5887 10.0385Z"
          fill="#FF7870"
        />
        <path
          d="M14.0962 10.0385C13.8879 10.0385 13.7188 10.2287 13.7188 10.4631C13.7188 10.6975 13.8879 10.8877 14.0962 10.8877C14.3046 10.8877 14.4737 10.6975 14.4737 10.4631C14.4737 10.2287 14.3046 10.0385 14.0962 10.0385Z"
          fill="#FF7870"
        />
      </g>
    </SvgIcon>
  );
});
